// extracted by mini-css-extract-plugin
export default {"root":"classes_root__D6WH9","title-container":"classes_title-container__TunVO","content":"classes_content__wxzf3","button-container":"classes_button-container__W+ZQr"};